<template>
  <div>
    <v-container class="pa-0 scrollable" fluid>
      <v-card v-if="feature" color="transparent" class="hyp-card mb-5" flat>
        <v-row>
          <v-col>
            <h2>{{ locationName }}</h2>
          </v-col>
        </v-row>

        <v-row v-if="location">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Location</div>
            <div class="hyp-text mt-1">
              {{ location }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="createdDate">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Incident Creation</div>
            <div class="hyp-text mt-1">
              <div class="pull-left">
                <v-icon color="black" size="15" class="mr-1"
                  >far fa-calendar-alt</v-icon
                >
                {{ createdDate }}
              </div>
              <div class="pull-left ml-3">
                <v-icon color="black" size="15" class="mr-1"
                  >far fa-clock</v-icon
                >
                {{ createdTime }} UTC
              </div>
              <div class="clearfix"></div>
            </div>
          </v-col>
        </v-row>

        <hr class="hyp-break mt-2" />

        <v-row>
          <v-col class="hyp-text text-center" cols="3">
            <div>
              <img
                class="categoryImage"
                :src="mainCategoryImageSrc"
                alt="category type"
              />
            </div>
            <div class="hyp-highlight-text application-heading">
              {{ mainCategoryName }}
            </div>
          </v-col>
          <v-col class="hyp-text" cols="6">
            <div class="hyp-heading application-heading">
              Precision Location / Region
            </div>
            <div class="hyp-text">
              <ul>
                <li>{{ locationPrecisionName }}</li>
                <li>{{ regionName }}</li>
              </ul>
            </div>
          </v-col>
        </v-row>

        <hr
          v-if="
            boarded ||
            pirates ||
            totalCrewHeld ||
            totalCrewInjured ||
            totalCrewDead ||
            stolenItems
          "
          class="hyp-break mb-3 mt-2"
        />

        <v-row v-if="boarded">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Boarded</div>
            <div class="hyp-text mt-1">
              {{ boarded }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="distanceOffshore">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Distance Offshore</div>
            <div class="hyp-text mt-1">{{ distanceOffshore }} miles</div>
          </v-col>
        </v-row>

        <v-row v-if="pirates">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Pirates</div>
            <div class="hyp-text mt-1">
              {{ pirates }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="attackers">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Attackers</div>
            <div class="hyp-text mt-1">
              {{ attackers }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="weapons">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Weapons</div>
            <div class="hyp-text mt-1">
              <ul>
                <li v-for="items in weapons" :key="items.Id">
                  {{ items.Name }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="securityInterventions">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Security Interventions
            </div>
            <div class="hyp-text mt-1">
              <ul>
                <li v-for="items in securityInterventions" :key="items.Id">
                  {{ items.Name }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="skiffs">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Skiffs</div>
            <div class="hyp-text mt-1">
              {{ skiffs }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="totalCrewHeld">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Crew Held Hostage</div>
            <div class="hyp-text mt-1">
              {{ totalCrewHeld }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="totalCrewInjured">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Crew Injuries</div>
            <div class="hyp-text mt-1">
              {{ totalCrewInjured }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="totalCrewDead">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Crew Fatalities</div>
            <div class="hyp-text mt-1">
              {{ totalCrewDead }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="stolenItems">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Stolen Items</div>
            <div class="hyp-text mt-1">
              <ul>
                <li v-for="items in stolenItems" :key="items.Id">
                  {{ items.Name }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>

        <hr v-if="outcomeTypes" class="hyp-break mb-3 mt-2" />

        <v-row v-if="outcomeTypes">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Outcomes</div>
            <v-row dense class="mt-1">
              <ul>
                <li v-for="type in outcomeTypes" :key="type.Id">
                  {{ type.Name }}
                </li>
              </ul>
            </v-row>
          </v-col>
        </v-row>

        <hr
          v-if="description || additionalDetails || incidentDetails"
          class="hyp-break mb-3 mt-2"
        />

        <v-row v-if="description">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Description</div>
            <div class="hyp-text mt-1">
              {{ description }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="incidentDetails">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Incident Details</div>
            <div class="hyp-text mt-1">
              {{ incidentDetails }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="additionalDetails">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Additional Details
            </div>
            <div class="hyp-text mt-1">
              {{ additionalDetails }}
            </div>
          </v-col>
        </v-row>

        <hr v-if="modifiedDate || modifiedTime" class="hyp-break mb-3 mt-2" />

        <v-row v-if="modifiedDate || modifiedTime">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Incident Modification
            </div>
            <div class="hyp-text mt-1">
              <div v-if="modifiedDate" class="pull-left">
                <v-icon color="black" size="15" class="mr-1"
                  >far fa-calendar-alt</v-icon
                >
                {{ modifiedDate }}
              </div>
              <div v-if="modifiedTime" class="pull-left ml-3">
                <v-icon color="black" size="15" class="mr-1"
                  >far fa-clock</v-icon
                >
                {{ modifiedTime }} UTC
              </div>
              <div class="clearfix"></div>
            </div>
          </v-col>
        </v-row>

        <hr v-if="vesselName" class="hyp-break mb-3 mt-2" />

        <v-row v-if="vesselName">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Name</div>
            <div class="hyp-text mt-1">
              {{ vesselName }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="vesselType">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Type</div>
            <div class="hyp-text mt-1">
              {{ vesselType }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="party">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Operator</div>
            <div class="hyp-text mt-1" v-html="party"></div>
          </v-col>
        </v-row>

        <v-row v-if="yearBuilt">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Year Built</div>
            <div class="hyp-text mt-1">
              {{ yearBuilt }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="imoNumber">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel IMO Number</div>
            <div class="hyp-text mt-1">
              {{ imoNumber }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="callSign">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Call Sign</div>
            <div class="hyp-text mt-1">
              {{ callSign }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="vesselCountry">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Country</div>
            <div class="hyp-text mt-1">
              <img
                v-if="vesselFlagUrl"
                :src="vesselFlagUrl"
                alt="flag"
                height="16"
                class="mr-1 hyp-vessel-flag"
              />
              <span class="hyp-vessel-country">{{ vesselCountry }}</span>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="vesselDisposition">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Vessel Disposition
            </div>
            <div class="hyp-text mt-1">
              {{ vesselDisposition }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="cargo">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">Vessel Cargo</div>
            <div class="hyp-text mt-1">
              {{ cargo }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="deadWeightTonnage">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Vessel Dead Weight Tonnage
            </div>
            <div class="hyp-text mt-1">
              {{ deadWeightTonnage | filterFormatNumber }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="grossRegisterTonnage">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Vessel Gross Registered Tonnage
            </div>
            <div class="hyp-text mt-1">
              {{ grossRegisterTonnage | filterFormatNumber }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="vesselCounterMeasures">
          <v-col class="hyp-text pt-0">
            <div class="hyp-heading application-heading">
              Vessel Counter Measures
            </div>
            <div class="hyp-text mt-1">
              <ul>
                <li v-for="items in vesselCounterMeasures" :key="items.Id">
                  {{ items.Name }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <div v-if="!feature">
        <Loader size="small" color="black" text="" class="ml-2 pt-10"></Loader>
      </div>
    </v-container>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import lodashGet from "lodash/get";
import lodashHas from "lodash/has";
import { findFlagUrlByIso3Code } from "country-flags-svg";

import { getCategoryIcon } from "@/services/controlRisks/incidents.service";

export default {
  name: "IncidentsDetailMaritime",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    feature: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mainCategoryName() {
      if (lodashGet(this.feature, "Categories[0].Name")) {
        return lodashGet(this.feature, "Categories[0].Name");
      }
      if (lodashGet(this.feature, "Category.Name")) {
        return lodashGet(this.feature, "Category.Name");
      }
      return null;
    },
    mainCategoryImageSrc() {
      if (lodashGet(this.feature, "Categories[0].Id")) {
        return getCategoryIcon(lodashGet(this.feature, "Categories[0].Id"));
      }
      if (lodashGet(this.feature, "Category.Id")) {
        return getCategoryIcon(lodashGet(this.feature, "Category.Id"));
      }
      return null;
    },
    subCategoryName() {
      if (lodashGet(this.feature, "SubCategories[0].Name")) {
        return lodashGet(this.feature, "SubCategories[0].Name");
      }
      if (lodashGet(this.feature, "SubCategory.Name")) {
        return lodashGet(this.feature, "SubCategory.Name");
      }
      return null;
    },
    subCategoryImageSrc() {
      if (lodashGet(this.feature, "SubCategories[0].Id")) {
        return getCategoryIcon(lodashGet(this.feature, "SubCategories[0].Id"));
      }
      if (lodashGet(this.feature, "SubCategory.Id")) {
        return getCategoryIcon(lodashGet(this.feature, "SubCategory.Id"));
      }
      return null;
    },
    locationName() {
      if (lodashGet(this.feature, "Country.Name")) {
        return this.feature.Country.Name;
      }
      if (lodashGet(this.feature, "Locality")) {
        return this.feature.Locality;
      }
      return null;
    },
    location() {
      if (
        lodashGet(this.feature, "Location.Lat") &&
        lodashGet(this.feature, "Location.Lon")
      ) {
        return `${this.feature.Location.Lat.toFixed(
          5
        )}, ${this.feature.Location.Lon.toFixed(5)}`;
      }
      return null;
    },
    createdDate() {
      if (this.feature.Created) {
        return dayjs(this.feature.Created).format("MMM D, YYYY");
      }
      return null;
    },
    createdTime() {
      if (this.feature.Created) {
        return dayjs(this.feature.Created).format("hh:mm");
      }
      return null;
    },
    modifiedDate() {
      if (this.feature.Modified) {
        return dayjs(this.feature.Modified).format("MMM D, YYYY");
      }
      return null;
    },
    modifiedTime() {
      if (this.feature.Modified) {
        return dayjs(this.feature.Modified).format("hh:mm");
      }
      return null;
    },
    modifiedDateDiffers() {
      return this.createdDate !== this.modifiedDate;
    },
    modifiedTimeDiffers() {
      return this.createdTime !== this.modifiedTime;
    },
    attackers() {
      if (this.feature && this.feature.Attackers) {
        return this.feature.Attackers;
      }
      return null;
    },
    boarded() {
      if (this.feature && this.feature.Boarded) {
        return this.feature.Boarded;
      }
      return null;
    },
    callSign() {
      if (this.feature && this.feature.CallSign) {
        return this.feature.CallSign;
      }
      return null;
    },
    cargo() {
      if (this.feature && this.feature.Cargo) {
        return this.feature.Cargo;
      }
      return null;
    },
    distanceOffshore() {
      if (this.feature && this.feature.DistanceOffshore) {
        return this.feature.DistanceOffshore;
      }
      return null;
    },
    deadWeightTonnage() {
      if (this.feature && this.feature.Dwt) {
        return this.feature.Dwt;
      }
      return null;
    },
    grossRegisterTonnage() {
      if (this.feature && this.feature.Grt) {
        return this.feature.Grt;
      }
      return null;
    },
    vesselCountry() {
      if (lodashGet(this.feature, "Flag.Name")) {
        return this.feature.Flag.Name;
      }
      return null;
    },
    vesselFlagUrl() {
      if (lodashGet(this.feature, "Flag.Code")) {
        const flagUrl = findFlagUrlByIso3Code(this.feature.Flag.Code);
        if (flagUrl) {
          return flagUrl;
        }
      }
      return null;
    },
    imoNumber() {
      if (this.feature && this.feature.Imo) {
        return this.feature.Imo;
      }
      return null;
    },
    outcomeTypes() {
      if (
        this.feature &&
        this.feature.OutcomeTypes &&
        this.feature.OutcomeTypes.length
      ) {
        return this.feature.OutcomeTypes;
      }
      return null;
    },
    party() {
      let party = [];
      if (lodashGet(this.feature, "Party.Id")) {
        party.push(this.feature.Party.Id);
      }
      if (lodashGet(this.feature, "Party.Nationality")) {
        party.push(this.feature.Party.Nationality);
      }
      if (lodashGet(this.feature, "Party.Type")) {
        party.push(this.feature.Party.Type);
      }
      if (party.length) {
        return party.join("<br>");
      }
      return null;
    },
    pirates() {
      if (this.feature && this.feature.Pirates) {
        return this.feature.Pirates;
      }
      return null;
    },
    port() {
      if (lodashGet(this.feature, "Port.Name")) {
        return this.feature.Port.Name;
      }
      return null;
    },
    securityInterventions() {
      if (
        this.feature &&
        this.feature.SecurityInterventions &&
        this.feature.SecurityInterventions.length
      ) {
        return this.feature.SecurityInterventions;
      }
      return null;
    },
    skiffs() {
      if (this.feature && this.feature.Skiffs) {
        return this.feature.Skiffs;
      }
      return null;
    },
    stolenItems() {
      if (
        this.feature &&
        this.feature.StolenItems &&
        this.feature.StolenItems.length
      ) {
        return this.feature.StolenItems;
      }
      return null;
    },
    totalCrewDead() {
      if (this.feature && this.feature.TotalCrewDead) {
        return this.feature.TotalCrewDead;
      }
      return null;
    },
    totalCrewHeld() {
      if (this.feature && this.feature.TotalCrewHeld) {
        return this.feature.TotalCrewHeld;
      }
      return null;
    },
    totalCrewInjured() {
      if (this.feature && this.feature.TotalCrewInjured) {
        return this.feature.TotalCrewInjured;
      }
      return null;
    },
    vesselCounterMeasures() {
      if (this.feature && this.feature.VesselCounterMeasures) {
        return this.feature.VesselCounterMeasures;
      }
      return null;
    },
    vesselName() {
      if (lodashGet(this.feature, "Vessel.Name")) {
        return this.feature.Vessel.Name;
      }
      return null;
    },
    vesselType() {
      if (lodashGet(this.feature, "Vessel.Type.Name")) {
        let type = this.feature.Vessel.Type.Name;
        if (lodashGet(this.feature, "Vessel.SubType.Name")) {
          type = `${type} - ${this.feature.Vessel.SubType.Name}`;
        }
        return type;
      }
      return null;
    },
    vesselDisposition() {
      if (lodashGet(this.feature, "Vessel.Disposition")) {
        return this.feature.Vessel.Disposition;
      }
      return null;
    },
    weapons() {
      if (this.feature && this.feature.Weapons && this.feature.Weapons.length) {
        return this.feature.Weapons;
      }
      return null;
    },
    yearBuilt() {
      if (this.feature && this.feature.YearBuilt) {
        return this.feature.YearBuilt;
      }
      return null;
    },
    water() {
      if (lodashGet(this.feature, "Water.Name")) {
        return this.feature.Water.Name;
      }
      return null;
    },
    locationPrecisionName() {
      if (lodashHas(this.feature, "LocationPrecision.Name")) {
        return lodashGet(this.feature, "LocationPrecision.Name");
      }
      return null;
    },
    regionName() {
      if (lodashHas(this.feature, "Region.Name")) {
        return lodashGet(this.feature, "Region.Name");
      }
      return null;
    },
    locality() {
      if (lodashHas(this.feature, "Locality")) {
        return lodashGet(this.feature, "RegLocality");
      }
      return null;
    },
    description() {
      if (this.feature && this.feature.Description) {
        return this.feature.Description;
      }
      return null;
    },
    incidentDetails() {
      if (this.feature && this.feature.IncidentDetails) {
        return this.feature.IncidentDetails;
      }
      return null;
    },
    additionalDetails() {
      if (this.feature && this.feature.AdditionalDetails) {
        return this.feature.AdditionalDetails;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.hyp-heading {
  font-size: 11px;
}
.hyp-text {
  font-size: 12px;
  color: #1c1c1c;
}
.hyp-break {
  height: 1px;
  background-color: #ccc;
  border: none;
}
.hyp-highlight-text {
  font-size: 14px;
}
.categoryImage {
  width: 44px;
  height: 44px;
}
.scrollable {
  height: 100vh;
  overflow-y: auto;
}
.hyp-vessel-flag {
  border: 1px #e2e2e2 solid;
}
.hyp-vessel-country {
  position: relative;
  top: -3px;
}
</style>
